import React, { FunctionComponent, useState, useEffect, useCallback } from 'react';
import { styled } from "@mui/material/styles";
import DashboardLayout from '../../../components/layout/layout';
import DesktopWindowsOutlinedIcon from '@mui/icons-material/DesktopWindowsOutlined';
import { Alert, Button, Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Typography, Box, Skeleton } from '@mui/material';
import { StyledSelect, StyledTextField } from '../../../components/ui/formInput';
import { useGetCities, useGetCountries, useGetStates } from '../../../hooks/api/common';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useUpdateCPUser, useGetChannelPartnersUsersByUserId } from '../../../hooks/api/otherextranet';
import moment from 'moment';

type ValidateField = {
    invalid: boolean;
    error: string;
};

type ValidateFieldsState = {
    firstName: ValidateField;
    lastName: ValidateField;
    title: ValidateField;
    email: ValidateField;
    phone: ValidateField;
    fax: ValidateField;
    addr1: ValidateField;
    addr2: ValidateField;
    city: ValidateField;
    state: ValidateField;
    zip: ValidateField;
    country: ValidateField;
};

const CheckboxUI = styled(Checkbox)(({ theme }) => ({
    color: 'red',
    '&.Mui-checked': {
        color: '#c3183c',
    },
}));

const UpdateUserFromUserList: FunctionComponent = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id: userId } = useParams();

    const [companyName, setCompanyName] = useState<string>('');
    const [numLogons, setnumLogons] = useState<string>('');
    const [lastLogon, setlastLogon] = useState<string>('');

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);

        const name = queryParams.get('name');
        const numLogons = queryParams.get('numLogons');
        const lastLogon = queryParams.get('lastLogon')

        setCompanyName(name ?? '');
        // setnumLogons(numLogons ?? '')
        // setlastLogon(lastLogon ?? '')
        setnumLogons(numLogons && numLogons.trim() !== '' ? numLogons : '0');
        setlastLogon(lastLogon && lastLogon.trim() !== '' ? lastLogon : '');

    }, [location.search, userId]);

    const [page, setPage] = useState(1);
    const size = 10;

    const { data: countries } = useGetCountries();
    const { mutateAsync: getStates } = useGetStates();
    const { mutateAsync: getCities } = useGetCities();
    const { data: CPUsersByUserId, isFetched: hasFetchedCPUsers, } = useGetChannelPartnersUsersByUserId(userId, page - 1, size);
    const { mutateAsync: editCPUser } = useUpdateCPUser();

    const formValidation: ValidateFieldsState = {
        firstName: { invalid: false, error: '' },
        lastName: { invalid: false, error: '' },
        title: { invalid: false, error: '' },
        email: { invalid: false, error: '' },
        phone: { invalid: false, error: '' },
        fax: { invalid: false, error: '' },
        addr1: { invalid: false, error: '' },
        addr2: { invalid: false, error: '' },
        city: { invalid: false, error: '' },
        state: { invalid: false, error: '' },
        zip: { invalid: false, error: '' },
        country: { invalid: false, error: '' },
    };

    const [validateFields, setValidateFields] = useState<ValidateFieldsState>(formValidation);
    const [error, setError] = useState<string>('');
    const [success, setSuccess] = useState<boolean>();
    const [stateList, setStateList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [selectedCountry, setSelectedCountry] = useState<string>("");
    const [disabled, setDisabled] = useState<boolean>(false);

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [title, setTitle] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [fax, setFax] = useState("");
    const [addr1, setAddr1] = useState("");
    const [addr2, setAddr2] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zip, setZip] = useState("");
    const [country, setCountry] = useState("");
    const [tempPassword, setTempPassword] = useState(false);
    const [cpAdmin, setCPAdmin] = useState(false);
    const [uploadInventory, setUploadInventory] = useState(false);
    const [enterOrders, setEnterOrders] = useState(false);
    const [dashboard, setDashboard] = useState(false);
    const [viewPriceLists, setViewPriceLists] = useState(false);
    const [forecast, setForecast] = useState(false);
    const [forecastEmail, setForecastEmail] = useState(false);

    const fetchStateCities = useCallback(
        async (countryCode: string, stateCode: string) => {
            const res = await getStates({ countryCode: countryCode });
            setStateList(res || []);

            const resCities = await getCities({ countryCode: countryCode, stateCode: stateCode });
            setCityList(resCities || []);
        },
        [getStates, getCities]
    );

    useEffect(() => {
        if (!userId || userId === '') {
            <Alert severity="error" sx={{ mt: 2 }}>
                UserId is null or empty!
            </Alert>
            navigate(-1);
        }
        if (CPUsersByUserId) {
            setFirstName(CPUsersByUserId.firstName);
            setLastName(CPUsersByUserId.lastName);
            setTitle(CPUsersByUserId.title);
            setEmail(CPUsersByUserId.email);
            setPhone(CPUsersByUserId.phone);
            setFax(CPUsersByUserId.fax);
            setAddr1(CPUsersByUserId.address);
            setAddr2(CPUsersByUserId.address2);
            setCity(CPUsersByUserId.city);
            setState(CPUsersByUserId.state);
            setZip(CPUsersByUserId.zip);
            setCountry(CPUsersByUserId.country);
            setTempPassword(CPUsersByUserId.tempPassword);
            setCPAdmin(CPUsersByUserId.cpAdmin);
            setUploadInventory(CPUsersByUserId.uploadInventory);
            setEnterOrders(CPUsersByUserId.enterOrders);
            setDashboard(CPUsersByUserId.dashboard);
            setViewPriceLists(CPUsersByUserId.viewPriceLists);
            setForecast(CPUsersByUserId.forecast);
            setForecastEmail(CPUsersByUserId.forecastEmail);
            setSelectedCountry(CPUsersByUserId.country);
            fetchStateCities(CPUsersByUserId.country, CPUsersByUserId.state);
        }
    }, [CPUsersByUserId, fetchStateCities]);

    const isValidEmail = (email: string) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    };

    const validateForm = () => {
        let valid = true;
        const errors = { ...validateFields };

        if (!firstName?.trim()) {
            errors.firstName = { invalid: true, error: 'First name is required' };
            valid = false;
        } else {
            errors.firstName = { invalid: false, error: '' };
        }

        if (!lastName?.trim()) {
            errors.lastName = { invalid: true, error: 'Last name is required' };
            valid = false;
        } else {
            errors.lastName = { invalid: false, error: '' };
        }

        if (!email?.trim()) {
            errors.email = { invalid: true, error: 'Email is required' };
            valid = false;
        } else if (!isValidEmail(email)) {
            errors.email = { invalid: true, error: 'Please enter a valid email address' };
            valid = false;
        } else {
            errors.email = { invalid: false, error: '' };
        }

        if (!phone?.trim()) {
            errors.phone = { invalid: true, error: 'Phone is required' };
            valid = false;
        } else if (phone?.trim() && !/^\+?[\d\s-]{7,15}$/.test(phone)) {
            errors.phone = { invalid: true, error: 'Please enter a valid phone number' };
            valid = false;
        } else {
            errors.phone = { invalid: false, error: '' };
        }

        if (!addr1?.trim()) {
            errors.addr1 = { invalid: true, error: 'Address is required' };
            valid = false;
        } else {
            errors.addr1 = { invalid: false, error: '' };
        }

        // if (!country) {
        //     errors.country = { invalid: true, error: 'Country is required' };
        //     valid = false;
        // } else {
        //     errors.country = { invalid: false, error: '' };
        // }

        // if (!state) {
        //     errors.state = { invalid: true, error: 'State is required' };
        //     valid = false;
        // } else {
        //     errors.state = { invalid: false, error: '' };
        // }

        // if (!city) {
        //     errors.city = { invalid: true, error: 'City is required' };
        //     valid = false;
        // } else {
        //     errors.city = { invalid: false, error: '' };
        // }

        // if (!zip?.trim()) {
        //     errors.zip = { invalid: true, error: 'ZIP code is required' };
        //     valid = false;
        // } else if (!/^\d{5}(-\d{4})?$/.test(zip)) {
        //     errors.zip = { invalid: true, error: 'Please enter a valid ZIP code (e.g. 12345 or 12345-6789)' };
        //     valid = false;
        // } else {
        //     errors.zip = { invalid: false, error: '' };
        // }

        setValidateFields(errors);
        return valid;
    };

    const handleFormAction = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setValidateFields(formValidation);
        if (!validateForm()) {
            return;
        }
        if (companyName === '') {
            return;
        }
        try {
            setDisabled(true);
            const result = await editCPUser({
                userId: CPUsersByUserId.userId.toString(),
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                title: title.trim(),
                email: email.toLowerCase().trim(),
                phone: phone.trim(),
                fax: fax.trim(),
                address: addr1.trim(),
                address2: addr2.trim(),
                city: city,
                state: state,
                zip: zip.trim(),
                country: country,
                tempPassword: tempPassword,
                cpAdmin: cpAdmin,
                uploadInventory: uploadInventory,
                enterOrders: enterOrders,
                dashboard: dashboard,
                viewPriceLists: viewPriceLists,
                forecast: forecast,
                forecastEmail: forecastEmail,

            });
            if (result?.status === 200) {
                setSuccess(true)
                setTimeout(() => {
                    setSuccess(false);
                    setFirstName('');
                    setLastName('');
                    setTitle('');
                    setEmail('');
                    setPhone('');
                    setFax('');
                    setAddr1('');
                    setAddr2('');
                    setCity('');
                    setState('');
                    setZip('');
                    setCountry('');
                    setTempPassword(false);
                    setCPAdmin(false);
                    setUploadInventory(false);
                    setEnterOrders(false);
                    setDashboard(false);
                    setViewPriceLists(false);
                    setForecast(true);
                    setForecastEmail(false);
                    setDisabled(false);
                }, 3000);
            } else {
                setDisabled(false);
                setError('An error occurred during login. Please try again.');
                setTimeout(() => {
                    setError('');
                }, 3000);
            }
        } catch (err: any) {
            setDisabled(false);
            if (err?.response?.data?.message) {
                setError(err.response.data.message);
            } else if (err?.message) {
                setError(err.message);
            } else {
                setError('An error occurred during login. Please try again.');
            }
        }
    }

    const fetchStates = async (countryCode: string) => {
        const res = await getStates({ countryCode: countryCode });
        setStateList(res || []);
    }

    const fetchCities = async (stateCode: string) => {
        const res = await getCities({ countryCode: selectedCountry, stateCode: stateCode });
        setCityList(res || []);
    }

    return (
        <>
            <DashboardLayout
                titleIcon={<DesktopWindowsOutlinedIcon />}
                title="Other Extranet"
                initialBreadcrumbs="Extranet/Barksdale Admin"
                levelBreadcrumbs=""
                breadcrumbs="Channel Partner User Edit"
                activeMenu="overview"
            >
                <form>
                    <Grid container sx={{ backgroundColor: '#f0f0f0', Width: '100%' }}>
                        <Box sx={{ flex: 1, pl: 2, borderRight: '1px solid #ccc' }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Company Name:
                            </Typography>
                            <Typography>{companyName}</Typography>
                        </Box>
                        <Box sx={{ flex: 1, borderRight: '1px solid #ccc' }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Number of Logons:
                            </Typography>

                            <Typography>{numLogons}</Typography>
                        </Box>
                        <Box sx={{ flex: 1, pl: 2 }}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                Last Logon:
                            </Typography>
                            <Typography>{lastLogon && moment(lastLogon).isValid()
                                ? moment(lastLogon).format('MM/DD/YYYY') : 'N/A'}</Typography>
                        </Box>
                    </Grid>
                    {
                        !hasFetchedCPUsers ? (
                            <>
                                <Skeleton width="38%" />
                                <Skeleton width="100%" />
                                <Skeleton width="100%" />
                                <Skeleton width="61%" />
                            </>
                        ) : (
                            <>
                                <Grid container spacing={2} sx={{ mt: 5 }}>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="First Name"
                                            value={firstName}
                                            onChange={(e: any) => setFirstName(e.target.value)}
                                            error={validateFields.firstName.invalid}
                                            helperText={validateFields.firstName.error}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Last Name"
                                            value={lastName}
                                            onChange={(e: any) => setLastName(e.target.value)}
                                            error={validateFields.lastName.invalid}
                                            helperText={validateFields.lastName.error}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Title"
                                            value={title}
                                            onChange={(e: any) => setTitle(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Email"
                                            value={email}
                                            onChange={(e: any) => setEmail(e.target.value)}
                                            error={validateFields.email.invalid}
                                            helperText={validateFields.email.error}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Phone"
                                            value={phone}
                                            onChange={(e: any) => setPhone(e.target.value)}
                                            error={validateFields.phone.invalid}
                                            helperText={validateFields.phone.error}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Fax"
                                            value={fax}
                                            onChange={(e: any) => setFax(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Address 1"
                                            value={addr1}
                                            onChange={(e: any) => setAddr1(e.target.value)}
                                            error={validateFields.addr1.invalid}
                                            helperText={validateFields.addr1.error}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Address 2"
                                            value={addr2}
                                            onChange={(e: any) => setAddr2(e.target.value)}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledSelect
                                            label="City"
                                            value={city}
                                            onChange={(e: any) => {
                                                setCity(e.target.value);
                                            }}
                                            error={validateFields.city.invalid}
                                            helperText={validateFields.city.error}
                                        >
                                            {
                                                cityList?.map((city: any) => (
                                                    <MenuItem key={city.id} value={city.id}>
                                                        {city.name}
                                                    </MenuItem>
                                                ))
                                            }
                                        </StyledSelect>
                                    </Grid>
                                    <Grid size={4}>
                                        <FormControl fullWidth>
                                            <StyledSelect
                                                label="State"
                                                value={state}
                                                onChange={(e: any) => {
                                                    setState(e.target.value);
                                                    fetchCities(e.target.value);
                                                }}
                                                error={validateFields.state.invalid}
                                                helperText={validateFields.state.error}
                                            >
                                                {
                                                    stateList?.map((states: any) => (
                                                        <MenuItem key={states.stateCode} value={states.stateCode}>
                                                            {states.name}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </StyledSelect>
                                        </FormControl>
                                    </Grid>
                                    <Grid size={4}>
                                        <StyledTextField
                                            label="Zip"
                                            value={zip}
                                            onChange={(e: any) => setZip(e.target.value)}
                                            error={validateFields.zip.invalid}
                                            helperText={validateFields.zip.error}
                                        />
                                    </Grid>
                                    <Grid size={4}>
                                        <FormControl fullWidth>
                                            <StyledSelect
                                                label="Country"
                                                value={country}
                                                onChange={(e: any) => {
                                                    setCountry(e.target.value);
                                                    setSelectedCountry(e.target.value);
                                                    fetchStates(e.target.value);
                                                }}
                                                error={validateFields.country.invalid}
                                                helperText={validateFields.country.error}
                                            >
                                                {
                                                    countries?.map((country: any) => (
                                                        <MenuItem key={country.iso2} value={country.iso2}>
                                                            {country.name}
                                                        </MenuItem>
                                                    ))
                                                }
                                            </StyledSelect>
                                        </FormControl>
                                    </Grid>
                                    <Grid size={12}>
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={tempPassword}
                                                    onChange={(e) => setTempPassword(e.target.checked)}
                                                />
                                            }
                                            label="Temp Password"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={cpAdmin}
                                                    onChange={(e) => setCPAdmin(e.target.checked)}
                                                />
                                            }
                                            label="CP Admin"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={uploadInventory}
                                                    onChange={(e) => setUploadInventory(e.target.checked)}
                                                />
                                            }
                                            label="Upload Inventory"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={enterOrders}
                                                    onChange={(e) => setEnterOrders(e.target.checked)}
                                                />
                                            }
                                            label="Enter Orders"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={dashboard}
                                                    onChange={(e) => setDashboard(e.target.checked)}
                                                />
                                            }
                                            label="Dashboard"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={viewPriceLists}
                                                    onChange={(e) => setViewPriceLists(e.target.checked)}
                                                />
                                            }
                                            label="View Price Lists"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={forecast}
                                                    onChange={(e) => setForecast(e.target.checked)}
                                                />
                                            }
                                            label="Forecast"
                                        />
                                        <FormControlLabel
                                            control={
                                                <CheckboxUI
                                                    checked={forecastEmail}
                                                    onChange={(e) => setForecastEmail(e.target.checked)}
                                                />
                                            }
                                            label="Forecast Email"
                                        />
                                    </Grid>
                                    <Grid size={12}>
                                        {error && (
                                            <Alert severity="error" sx={{ mt: 2 }}>
                                                {error}
                                            </Alert>
                                        )}
                                        {
                                            success && (
                                                <Alert severity="success" sx={{ mt: 2 }}>
                                                    User Updated successfully!
                                                </Alert>
                                            )
                                        }
                                    </Grid>
                                    <Grid size={12}>
                                        <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '150px', marginRight: '25px' }} onClick={handleFormAction}>
                                            UPDATE USER
                                        </Button>
                                        <Button disabled={disabled} variant="contained" sx={{ backgroundColor: '#c3183c', padding: '6px 25px !important', minWidth: '150px' }} onClick={() => navigate(-1)}>
                                            CANCEL

                                        </Button>
                                    </Grid>
                                </Grid>
                            </>
                        )
                    }
                </form>
            </DashboardLayout>
        </>
    )
};

export default UpdateUserFromUserList;

